import Vue from "vue";
import Router from "vue-router";
import Home from "@/components/Pages/Home/PageHome";
import Search from "@/components/Pages/SearchResults/PageSearchResults";
import TracksCreate from "@/components/Pages/TracksCreate/PageTracksCreate";
import PageTrack from "@/components/Pages/PageTrack";
import TrackEdit from "@/components/Pages/PageTrackEdit";
import Register from "@/components/Pages/PageRegister";
import Login from "@/components/Pages/PageLogin";
import Logout from "@/components/Pages/PageLogout";
import NotFound from "@/components/Pages/PageNotFound";
import Test from "@/components/Test";
import User from "@/components/Pages/PageUser";
import UserHome from "@/components/Pages/PageUserHome";
import UserPlaylists from "@/components/Pages/PageUserPlaylists";
import UserChannels from "@/components/Pages/PageUserChannels";
import PlaylistEdit from "@/components/Pages/PagePlaylistEdit";
import Playlist from "@/components/Pages/PagePlaylist";
import Likes from "@/components/Pages/PageLikes";
import History from "@/components/Pages/PageHistory";
import Subscriptions from "@/components/Pages/PageSubscriptions";
import PageBrowse from "@/components/Pages/PageBrowse";
import TestPlayer from "@/components/AudioPlayer";
Vue.use(Router);
export default new Router({
    mode: "history",
    scrollBehavior: function (to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition;
        }
        else {
            return { x: 0, y: 0 };
        }
    },
    linkActiveClass: "active",
    routes: [
        { path: "/", name: "Home", component: Home, redirect: "/browse" },
        { path: "/register", name: "Register", component: Register, meta: { forAuth: false, } },
        { path: "/login", name: "Login", component: Login, meta: { forAuth: false, } },
        { path: "/logout", name: "Logout", component: Logout },
        { path: "/browse", name: "Browse", component: PageBrowse },
        { path: "/subscriptions", name: "Subscriptions", component: Subscriptions },
        {
            path: "/users/:id", name: "User", component: User, props: true,
            children: [
                { path: "home", alias: "", name: "UserHome", component: UserHome, },
                { path: "playlists", name: "UserPlaylists", component: UserPlaylists, props: true, },
                { path: "channels", name: "UserChannels", component: UserChannels, props: true, },
            ],
        },
        { path: "/tracks/add", name: "TracksCreate", component: TracksCreate, meta: { forAuth: true, }, },
        { path: "/tracks/:id", name: "Track", props: true, component: PageTrack },
        { path: "/tracks/:id/edit", name: "TrackEdit", props: true, component: TrackEdit, meta: { forAuth: true, }, },
        { path: "/playlists/:id/edit", name: "PlaylistEdit", props: true, component: PlaylistEdit, meta: { forAuth: true, }, },
        { path: "/playlists/:id", name: "Playlist", props: true, component: Playlist, },
        { path: "/likes", name: "Likes", component: Likes, },
        { path: "/history", name: "History", component: History, },
        { path: "/search/:q", name: "Search", component: Search, props: true, },
        { path: "*", component: NotFound },
        { path: "/test", component: Test },
        { path: "/test-player", component: TestPlayer },
    ]
});



//////////////////
// WEBPACK FOOTER
// ./src/router/index.ts
// module id = 67
// module chunks = 0